import { RefObject, useEffect, useState } from 'react';

import { useMounted } from '../lifecycle/mount';

export function useCheckScrollable(direction: 'vertical' | 'horizontal', ref: RefObject<HTMLElement | null>) {
  const isMounted = useMounted();

  const [isScrollable, setIsScrollable] = useState(false);

  const dom = ref.current;

  useEffect(() => {
    const checkScrollable = () => {
      let currentScrollable = false;
      if (dom && direction === 'horizontal') currentScrollable = dom.scrollWidth > dom.clientWidth;
      if (dom && direction === 'vertical') currentScrollable = dom.scrollHeight > dom.clientHeight;
      setIsScrollable(currentScrollable);
    };

    if (!isMounted || !dom) return;

    checkScrollable();

    const observer = new ResizeObserver(checkScrollable);
    observer.observe(dom);

    return () => {
      observer.disconnect();
    };
  }, [isMounted, dom, direction]);

  return isScrollable;
}
